import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';

import logo from '../../assets/images/logo_header.svg';
import navArrowLeft from '../../assets/images/nav_arrow_left.svg';
import loadGif from '../../assets/images/loading.gif';

import './RouteNotFound.css';


class Component extends React.Component {
  constructor(props) {
    super(props);

    const s = {
      backTo: 'Home',
      path: '/',
    };

    if (props.authToken) {
      s.backTo = 'Account';
      s.path = '/portfolio';
    }

    this.state = s;
    this.redirect = setTimeout(() => {
      props.history.push(this.state.path);
    }, 8000);
  }

  componentWillUnmount() {
    clearTimeout(this.redirect);
  }

  render() {
    return (
      <div styleName="RouteNotFound">
        <div styleName="top">
          <Link
            to={this.state.path}
            styleName="homeButton"
          >
            <img
              src={navArrowLeft}
              alt="Back Arrow"
              styleName="backArrow"
            />
            { this.state.backTo }
          </Link>
          <img
            src={logo}
            alt="My IPO"
            styleName="logo"
          />
        </div>
        <div styleName="container">
          <div styleName="mainText">
            { "The page you've requested doesn't exist" }
          </div>
          <div styleName="subText">
            { `We're redirecting you to the ${this.state.backTo} page ...` }
          </div>
          <img
            src={loadGif}
            alt="Loading"
          />
        </div>
      </div>
    );
  }
}

Component.displayName = 'RouteNotFound';

const mapStateToProps = state => ({
  authToken: state.authToken,
});

const enhance = compose(
  connect(mapStateToProps),
  withRouter,
);

export default enhance(Component);



// WEBPACK FOOTER //
// ./src/components/App/RouteNotFound.js